import type { TPatientInfo } from 'store/ccm/console';
import type { IQueueTableData } from 'infrastructure/interfaces';

interface PatientInfoLike {
  guid: string;
  name?: string;
  firstName?: string | null;
  lastName?: string | null;
  birthDate?: string | null;
  language?: string | null;
  provider?: string | null;
}

const splitName = (fullName?: string) => {
  if (!fullName) return { firstName: '', lastName: '' };
  const parts = fullName
    .split(/\s+/)
    .map((part) => part.trim())
    .filter(Boolean);
  if (parts.length === 0) {
    return { firstName: '', lastName: '' };
  }
  if (parts.length === 1) {
    return { firstName: parts[0], lastName: '' };
  }
  return { firstName: parts[0], lastName: parts.slice(1).join(' ') };
};

export const buildPatientInfo = (
  source: PatientInfoLike | (IQueueTableData & PatientInfoLike),
): TPatientInfo => {
  const fallbackNames = splitName(source.name);
  const firstName = source.firstName ?? fallbackNames.firstName;
  const lastName = source.lastName ?? fallbackNames.lastName;

  return {
    guid: source.guid,
    firstName,
    lastName,
    birthDate: source.birthDate ?? null,
    language: source.language ?? null,
    doctorName: source.provider ?? null,
  };
};
